module.exports = {
      id: "clock-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "svg-sprite-f0666e191f9085fc3de3ed484b6b7fae.svg#clock",
      toString: function () {
        return this.url;
      }
    }